import React from 'react';
import { AssignableUser, DataSiteEmailTrackingData } from '$/core/models';
import { resolveTaskType } from './taskModal.types';
import taskModalRegistry from './taskModalRegistry';

interface CreateTaskModalProps {
  isOpen: boolean;
  taskData: DataSiteEmailTrackingData | null;
  assigneeList?: AssignableUser[];
  onClose: () => void;
  onTaskCreated: (assigneeId: string | null) => Promise<void>;
}

/**
 * Resolves the correct modal component from the registry based on the task data,
 * and renders it. Adding a new task type requires no changes here.
 */
const CreateTaskModal: React.FC<CreateTaskModalProps> = ({
  isOpen,
  taskData,
  assigneeList,
  onClose,
  onTaskCreated,
}) => {
  if (!taskData) return null;

  const taskType = resolveTaskType(taskData);
  const ModalComponent = taskModalRegistry[taskType];

  return (
    <ModalComponent
      isOpen={isOpen}
      taskData={taskData}
      assigneeList={assigneeList}
      onClose={onClose}
      onTaskCreated={onTaskCreated}
    />
  );
};

export default CreateTaskModal;
